import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from '../shared/shared.module';
import { SupervisionOperationsModule } from './pages/supervision-operations/supervision-operations.module';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalHttpInterceptorService } from '../shared/services/global-http-interceptor.service';

import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthGuard } from '../core/guard/auth.guard';
import { GuestGuard } from '../core/guard/guest.guard';
import { NotifyService } from '../shared/services/notify.service';
import { PrimeNGConfig } from 'primeng/api';
import { provideRouter } from '@angular/router';
import { routes } from './app-routing.module';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(withInterceptorsFromDi()),

        importProvidersFrom(
            BrowserAnimationsModule,
            OverlayModule,
            NgbModule,
            ToastrModule.forRoot(),
            SharedModule,
            SupervisionOperationsModule
        ),

        provideRouter(routes),

        provideTranslateService({
            lang: 'fr',
            fallbackLang: 'en',
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json',
            }),
        }),

        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalHttpInterceptorService,
            multi: true,
        },
        CookieService,
        LocalStorageService,
        NotifyService,
        AuthGuard,
        GuestGuard,
        PrimeNGConfig,
    ],
};
